import { useSession } from 'next-auth/react';

import { HeaderBlock } from '@/blocks/header-block';
import { Box } from '@/components/box';
import { QuoteForm } from '@/components/forms/quote-form';
import { PageLayout } from '@/components/layouts/page-layout';
import { LoadingSpinner } from '@/components/ui/loading/spinner';
import { NEXT_AUTH_STATUSES, SITE_DOMAIN } from '@/lib/constants';
import { PostSnippets } from '@/types/cms-types';
import { cmsPostService } from '@/utils/api/services/cms.service/post';
import { createMetaTagsWithCustomTitleAndDescription } from '@/utils/helpers';

const QuotePage = ({ posts }: { posts: PostSnippets }) => {
  const seoMetaTags = createMetaTagsWithCustomTitleAndDescription({
    title: 'Get a quote',
    description: 'Get a shipping quote for your cargo delivery',
  });

  const { status } = useSession();

  return (
    <PageLayout metaTags={seoMetaTags} canonical={`${SITE_DOMAIN}/get-a-quote`} headerVariant="dark" posts={posts}>
      <div className="blocks">
        <HeaderBlock
          id="quote-page-header-block"
          heading="Shipping Enquiry"
          body="<p>Ensure the fastest response by providing as much detail about your shipment as possible.</p>"
          headingElement="h1"
          variant="sm"
        />

        {status !== NEXT_AUTH_STATUSES.LOADING ? (
          <QuoteForm />
        ) : (
          <Box minHeight="400px" position="relative">
            <LoadingSpinner isVisible />
          </Box>
        )}
      </div>
    </PageLayout>
  );
};

export const getStaticProps = async () => {
  const posts = await cmsPostService.getPostSnippetsCached();

  return {
    props: { posts },
  };
};

export default QuotePage;
